<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h1 class="h1">Informe Licencias Facturables</h1>
      </b-col>
      <b-col class="col text-right">
        <b-button class="p-2 m-2" variant="outline-success" @click="print">
          <b-icon icon="printer-fill"></b-icon>
          Imprimir
        </b-button>
      </b-col>
    </b-row>

    <div id="printMe">
      <b-row>
        <b-col cols="3"><b> Nombre: {{ this.llicencies.length }}</b></b-col>
        <b-col cols="3"></b-col>
        <b-col cols="6"><b> Import(€): {{ totalInvoice }}</b></b-col>
      </b-row>
      </p>
      <b>Por Cliente</b>
      <b-container class="bv-example-row">
        <b-row class="justify-content-md-center">
          <b-col cols="3"></b-col>
          <b-col cols="3">Número de Licencias</b-col>
          <b-col cols="6">Detalle</b-col>
        </b-row>       
        <div v-for="item in this.llicenciesAgrupades">
          <b-row>
            <b-col cols="3">{{item.cliente}}</b-col>
            <b-col cols="3">{{item.licencias.length}}</b-col>
            <b-col cols="6">
              <b-row v-for="taller in item.licencias"> 
                <b-col>{{taller.titulo}}</b-col>
              </b-row>
            </b-col>               
          </b-row>
          </p>
        </div>  
      </b-container>

 

    </div>
  </b-container>
</template>

<script>
  import DataAccess from "@/Services/DataAccess.js";
  import moment from "moment";

  export default {
    computed: {
      totalInvoice: function () {
        let sum = 0;
        this.llicencies.forEach(function (item) {
          sum += parseFloat(item.productoPrecio);
        });
        return sum;
      },
    },
    data() {
      return {
        llicencies: [],
        llicenciesAgrupades: [],
      };
    },
    created() {
      (async () => {
        var url = "/api/InformesLicencias/LicenciasTalleres";
        await DataAccess.getData(url)
          .then((response) => {
            this.llicencies = response.data;
            this.getlicenciasXCliente();
            this.loading = false;
          })
          .catch((error) => {
            console.log("ERROR: ", error);
          });
      })();
    },
    methods: {
      getActualMonth() {
        var date = Date();
        return moment(date).add(1, "months").locale("es").format("MMMM");
      },
      print() {
        // Pass the element id here
        this.$htmlToPaper("printMe");
      },
      getlicenciasXCliente(){
        this.llicencies.forEach( x => {
          const cli = x.cliente.nombre;
          if (!this.llicenciesAgrupades.find(x => x.cliente == cli)) 
          {
              this.llicenciesAgrupades.push({
                cliente: x.cliente.nombre,
                licencias: [{titulo: x.productoTitulo}]
              });
          }
          else{
            const index = this.llicenciesAgrupades.findIndex(x => x.cliente == cli);
            this.llicenciesAgrupades[index].licencias.push({titulo: x.productoTitulo});
          }
        });
        // console.log("Licencias: ", this.llicenciesAgrupades);
      },
  },
}
</script>

<style lang="scss" scoped>
</style>
